var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrustStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "single-star-transparent-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Light-",
    transform: "translate(-518.000000, -3930.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(161.000000, 3469.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trust",
    transform: "translate(236.000000, 456.725581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "single-star-transparent-2",
    transform: "translate(121.000000, 4.274419)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00B67A",
    points: "0 0 28.75 0 28.75 29 0 29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0946085,18.5444573 L18.395261,17.4039136 L20.2079327,22.999706 L14.0946085,18.5444573 L14.0946085,18.5444573 Z M24.010989,11.3091334 L16.4048764,11.3091334 L14.0590659,4.07380952 L11.7132555,11.3091334 L4.10714286,11.3091334 L10.2560096,15.8000241 L7.91019918,23.035348 L14.0590659,18.5800993 L17.8621223,15.8000241 L24.010989,11.3091334 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustStars);
export default __webpack_public_path__ + "static/media/trustStars.1df649ab0ac572cf2202cfb3bde99cf0.svg";
export { ForwardRef as ReactComponent };